/**
 * Solution Section Slider
 * Handles Swiper slider initialization with coverflow effect and tab navigation
 */

(function($) {
	'use strict';

	const solutionSection = document.getElementById('solution-section');
	if (!solutionSection) {
		return;
	}

	const $contentSlider = $('.solution-section__content');
	const $tabsContainer = $('.solution-section__tabs');
	const $tabs = $('.solution-section__tab'); // Tabs are now inside .swiper-slide on mobile

	if ($contentSlider.length === 0 || $tabsContainer.length === 0) {
		return;
	}

	let swiper = null;
	let tabsSwiper = null;

	// Check if we're on mobile (below 768px)
	function isMobile() {
		return window.innerWidth < 768;
	}

	// Initialize content slider with Swiper
	function initContentSlider() {
		// Destroy existing Swiper instance if exists
		if (swiper) {
			swiper.destroy(true, true);
			swiper = null;
		}

		if (typeof Swiper === 'undefined') {
			console.error('Swiper is not loaded');
			return;
		}

		if (isMobile()) {
			// Mobile: simple slide effect
			// On mobile, cloned slides are hidden via CSS but still in DOM
			// We need to ensure Swiper doesn't navigate to hidden cloned slides
			swiper = new Swiper('.solution-section__content', {
				direction: 'horizontal',
				effect: 'slide',
				slidesPerView: 1,
				spaceBetween: 20,
				centeredSlides: true,
				loop: false,
				speed: 600,
				grabCursor: true,
				// Prevent navigation to hidden slides
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
				// Prevent Swiper from snapping to cloned slides
				preventInteractionOnTransition: true,
				on: {
					init: function() {
						// On mobile: remove cloned slides from DOM to prevent navigation issues
						const slides = this.slides;
						const slidesToRemove = [];

						// Find all cloned slides
						for (let i = slides.length - 1; i >= 0; i--) {
							const $slide = $(slides[i]);
							const slideDataIndex = $slide.attr('data-slide-index');

							if ($slide.hasClass('swiper-slide-clone') || (slideDataIndex && slideDataIndex.toString().startsWith('clone-'))) {
								slidesToRemove.push(i);
							}
						}

						// Remove cloned slides from DOM (iterate backwards to maintain indices)
						for (let i = 0; i < slidesToRemove.length; i++) {
							const slideIndex = slidesToRemove[i];
							const $slide = $(slides[slideIndex]);
							$slide.remove();
						}

						// Reinitialize Swiper to update slides array
						this.update();

						// Find slide with data-slide-index="0" and navigate to it
						const updatedSlides = this.slides;
						for (let i = 0; i < updatedSlides.length; i++) {
							const $slide = $(updatedSlides[i]);
							const slideDataIndex = $slide.attr('data-slide-index');

							// Look for slide with data-slide-index="0"
							const slideIndex = parseInt(slideDataIndex, 10);
							if (!isNaN(slideIndex) && slideIndex === 0) {
								this.slideTo(i, 0);
								updateActiveTab(0);
								return;
							}
						}
					},
					slideChange: function() {
						// Get data-slide-index from active slide and use it as tab index
						const activeSlide = this.slides[this.activeIndex];

						if (activeSlide) {
							const $activeSlide = $(activeSlide);
							const slideDataIndex = $activeSlide.attr('data-slide-index');

							// Use data-slide-index as tab index
							const tabIndex = parseInt(slideDataIndex, 10);
							if (!isNaN(tabIndex) && tabIndex >= 0) {
								updateActiveTab(tabIndex);
							}
						}
					},
				},
			});
		} else {
			// Desktop: coverflow effect with 3D transformation
			// Loop mode doesn't work well with coverflow and tab navigation
			// Disabling loop for better tab switching reliability
			swiper = new Swiper('.solution-section__content', {
				direction: 'horizontal',
				effect: 'coverflow',
				grabCursor: false,
				allowTouchMove: false,
				centeredSlides: true,
				slidesPerView: 'auto',
				spaceBetween: -60,
				coverflowEffect: {
					rotate: -50,
					stretch: 0,
					depth: 100,
					modifier: 1,
					slideShadows: false,
				},
				speed: 800,
				loop: false,
				watchSlidesProgress: true,
				watchSlidesVisibility: true,
				on: {
					init: function() {
						// Update tab on initialization
						// First real slide is at index 1 (after cloned last slide)
						const activeIndex = this.activeIndex;
						const realIndex = activeIndex > 0 ? activeIndex - 1 : 0;
						updateActiveTab(realIndex);
					},
					slideChange: function() {
						// Update tab on slide change
						// First real slide is at index 1 (after cloned last slide)
						const activeIndex = this.activeIndex;
						const realIndex = activeIndex > 0 ? activeIndex - 1 : 0;
						updateActiveTab(realIndex);
					},
				},
			});
		}
	}

	// Initialize tabs slider (mobile only) - using Swiper
	function initTabsSlider() {
		// Destroy existing Swiper instance if exists
		if (tabsSwiper) {
			tabsSwiper.destroy(true, true);
			tabsSwiper = null;
		}

		if (typeof Swiper === 'undefined') {
			return;
		}

		if (isMobile()) {
			// Initialize Swiper for tabs on mobile
			tabsSwiper = new Swiper('.solution-section__tabs', {
				direction: 'horizontal',
				slidesPerView: 'auto',
				spaceBetween: 12,
				freeMode: false, // Disable freeMode to enable centering
				centeredSlides: true, // Center active slide
				centeredSlidesBounds: true, // First and last slides stick to edges, others center
				grabCursor: true,
				watchSlidesProgress: true,
				// Allow clicking on tabs
				allowTouchMove: true,
				// Prevent Swiper from interfering with tab clicks
				simulateTouch: true,
				touchRatio: 1,
				touchAngle: 45,
				threshold: 5,
				// Allow scrolling to the end
				resistance: true,
				resistanceRatio: 0.85,
			});
		}
	}

	// Update active tab based on slide index
	function updateActiveTab(slideIndex) {
		// Ensure index is within valid range
		const tabsCount = $tabs.length;
		if (slideIndex < 0 || slideIndex >= tabsCount) {
			return;
		}

		$tabs.removeClass('solution-section__tab--active');
		const $activeTab = $tabs.eq(slideIndex);
		if ($activeTab.length) {
			$activeTab.addClass('solution-section__tab--active');
		}

		// Scroll to active tab in mobile slider
		// With centeredSlidesBounds: first and last tabs stick to edges, others center
		if (isMobile() && tabsSwiper && tabsSwiper.initialized) {
			setTimeout(function() {
				try {
					// Scroll to active tab smoothly
					// Swiper will automatically center it (except first/last which stick to edges)
					tabsSwiper.slideTo(slideIndex, 300);
				} catch (e) {
					console.warn('Tabs Swiper slideTo error:', e);
				}
			}, 100);
		}
	}

	// Handle tab click
	$tabs.off('click.solution');
	$tabs.on('click.solution', function(e) {
		// Prevent event from bubbling, but allow Swiper to handle swipes
		e.stopPropagation();

		const tabIndex = parseInt($(this).attr('data-tab-index'), 10);

		if (!isNaN(tabIndex) && swiper && swiper.initialized) {
			// Prevent multiple rapid clicks
			if (swiper.animating) {
				return false;
			}

			// Find slide with data-slide-index matching tabIndex
			// Skip cloned slides (they have "clone-" prefix in data-slide-index)
			const slides = swiper.slides;
			let targetSlideIndex = -1;

			for (let i = 0; i < slides.length; i++) {
				const $slide = $(slides[i]);
				const slideDataIndex = $slide.attr('data-slide-index');
				const isClone = $slide.hasClass('swiper-slide-clone');

				// Skip cloned slides (they have "clone-" prefix or class)
				if (isClone || (slideDataIndex && slideDataIndex.toString().startsWith('clone-'))) {
					continue;
				}

				// Match by data-slide-index (should be exactly tabIndex for real slides)
				const slideIndex = parseInt(slideDataIndex, 10);
				if (!isNaN(slideIndex) && slideIndex === tabIndex) {
					targetSlideIndex = i;
					break;
				}
			}

			// Navigate to found slide
			if (targetSlideIndex >= 0 && targetSlideIndex < slides.length) {
				swiper.slideTo(targetSlideIndex, 600);

				// Double-check after transition that we're on the correct slide
				setTimeout(function() {
					const newActiveIndex = swiper.activeIndex;
					const $newActiveSlide = $(swiper.slides[newActiveIndex]);
					const newSlideDataIndex = $newActiveSlide.attr('data-slide-index');
					const isNewClone = $newActiveSlide.hasClass('swiper-slide-clone');

					// If we ended up on a cloned slide, find and move to the real one
					if (isNewClone || (newSlideDataIndex && newSlideDataIndex.toString().startsWith('clone-'))) {
						// Find real slide with matching tabIndex
						for (let i = 0; i < slides.length; i++) {
							const $slide = $(slides[i]);
							const slideDataIdx = $slide.attr('data-slide-index');

							if (!$slide.hasClass('swiper-slide-clone') && slideDataIdx && !slideDataIdx.toString().startsWith('clone-')) {
								const slideIdx = parseInt(slideDataIdx, 10);
								if (!isNaN(slideIdx) && slideIdx === tabIndex) {
									swiper.slideTo(i, 0);
									break;
								}
							}
						}
					}
				}, 650);
			}

			return false;
		}

		return false;
	});

	// Initialize on load
	$(document).ready(function() {
		initContentSlider();
		initTabsSlider();

		// Set initial active tab after a short delay to ensure Swiper is initialized
		setTimeout(function() {
			if (swiper && swiper.initialized) {
				if (isMobile()) {
					// Get data-slide-index from active slide and use it as tab index
					const activeSlide = swiper.slides[swiper.activeIndex];
					if (activeSlide) {
						const $activeSlide = $(activeSlide);
						const slideDataIndex = $activeSlide.attr('data-slide-index');

						// Skip cloned slides - if on cloned slide, find and move to real slide with index 0
						if ($activeSlide.hasClass('swiper-slide-clone') || (slideDataIndex && slideDataIndex.toString().startsWith('clone-'))) {
							// Find slide with data-slide-index="0"
							const slides = swiper.slides;
							for (let i = 0; i < slides.length; i++) {
								const $slide = $(slides[i]);
								const slideDataIdx = $slide.attr('data-slide-index');

								if (!$slide.hasClass('swiper-slide-clone') && slideDataIdx && !slideDataIdx.toString().startsWith('clone-')) {
									const slideIdx = parseInt(slideDataIdx, 10);
									if (!isNaN(slideIdx) && slideIdx === 0) {
										swiper.slideTo(i, 0);
										updateActiveTab(0);
										break;
									}
								}
							}
						} else {
							// Use data-slide-index as tab index
							const tabIndex = parseInt(slideDataIndex, 10);
							if (!isNaN(tabIndex) && tabIndex >= 0) {
								updateActiveTab(tabIndex);
							}
						}
					}
				} else {
					// Desktop: First real slide is at index 1 (after cloned last slide)
					const currentSlide = swiper.activeIndex;
					const realIndex = currentSlide > 0 ? currentSlide - 1 : 0;
					updateActiveTab(realIndex);
					if (currentSlide === 0) {
						// Defer slideTo until after next paint so clone can render and eager images start loading
						requestAnimationFrame(function() {
							requestAnimationFrame(function() {
								if (swiper && swiper.initialized && swiper.activeIndex === 0) {
									swiper.slideTo(1, 0);
								}
							});
						});
					}
				}
			}
		}, 100);
	});

	// Reinitialize on resize
	let resizeTimer;
	$(window).on('resize', function() {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function() {
			initContentSlider();
			initTabsSlider();
			if (swiper && swiper.initialized) {
				if (isMobile()) {
					// Get data-slide-index from active slide and use it as tab index
					const activeSlide = swiper.slides[swiper.activeIndex];
					if (activeSlide) {
						const $activeSlide = $(activeSlide);
						const slideDataIndex = $activeSlide.attr('data-slide-index');

						// Skip cloned slides
						if (!$activeSlide.hasClass('swiper-slide-clone') && slideDataIndex && !slideDataIndex.toString().startsWith('clone-')) {
							const tabIndex = parseInt(slideDataIndex, 10);
							if (!isNaN(tabIndex) && tabIndex >= 0) {
								updateActiveTab(tabIndex);
							}
						}
					}
				} else {
					// Desktop: First real slide is at index 1 (after cloned last slide)
					const currentSlide = swiper.activeIndex;
					const realIndex = currentSlide > 0 ? currentSlide - 1 : 0;
					updateActiveTab(realIndex);
				}
			}
		}, 250);
	});

})(jQuery);
